import { snapshotAll, resetSandbox, applySnapshot, applyDeferScriptInPage } from "./sandbox";
import { animationNextPage, parsePage } from "./dom";
import { getGlobalLightHub, getAsyncQueueId, runInQueue, isLightWran, runInOriginTimeout, timeout } from "./utils";
import { SnapShot, Page, PageInstance } from "./typing";
import { dispatchPageVisibilityEvent, dispatchLighthubEvent, dispatchEvent } from './event';
import hijackPerformanceTiming, { hijackRequestStart, hijackResponseStart } from "./hijack/performance-timing";
import nprogress from 'nprogress';
import hijackReadyState from "./hijack/readystate";
import { logger, timer } from "./logger";
import { startTiming, endTiming } from "./timing";

const historyStack = [] as SnapShot[];
let currentIndex = -1;

export function applyURL(url: string, lastSnapshot: SnapShot) {
    historyStack[currentIndex] = lastSnapshot;

    if (historyStack[currentIndex - 5]) {
        delete historyStack[currentIndex - 5];
    }

    

    currentIndex ++;

    dispatchLighthubEvent('beforeback');

    history.pushState({$lighthubIndex: currentIndex}, document.head.title, url);
    lastHref = location.origin + location.pathname;
}

let lastHref = location.origin + location.pathname;

export function registerNavigation() {
    getGlobalLightHub().origins._windowAddEventListener.call(window, 'popstate', async (e: any) => {
        
        if (lastHref === location.origin + location.pathname) {
            // hashchange
            return;
        }

        if (!e.state) {
            // must be back
            currentIndex = -1;
        } else {
            currentIndex = e.state.$lighthubIndex;
        }

        const lighthub = getGlobalLightHub();
        lighthub.asyncQueueId += 1;

        

        const lastSnapshot = historyStack[currentIndex];
        delete historyStack[currentIndex];

        if (lastSnapshot) {
            const currentSnapshot = snapshotAll();
            historyStack[currentIndex] = currentSnapshot;

            await runInQueue(() => applySnapshot(lastSnapshot, true));

            lastHref = location.origin + location.pathname;
            dispatchPageVisibilityEvent(false);
            dispatchLighthubEvent('afterback');
        } else {
            location.reload();
        }
    });

}

export const navigateTo = async (url: string) => {
    try {
        

        // take a snapshot before navigation
        const lighthub = getGlobalLightHub();
        const _targetPage = lighthub.pages.find(item => item.match(url));
        if (!_targetPage) {
            console.warn('Try to navigation to a non-register page: ', url);
            return;
        }

        const targetPage = _targetPage as PageInstance;
        lighthub.asyncQueueId += 1;

        let snapshot;

        const asyncQueueId = getAsyncQueueId();

        const entryPromise = targetPage.entry(url);

        runInOriginTimeout(() => {
            if (targetPage.beforeNavigation) {
                targetPage.beforeNavigation(url);
            }
        });

        // dispatchEvent('beforeunload');

        dispatchPageVisibilityEvent(true);

        dispatchEvent('pagehide');
        dispatchEvent('unload')

        dispatchLighthubEvent('beforenavigation');

        
        snapshot = snapshotAll();
        

        
        await resetSandbox();
        

        applyURL(targetPage.updateUrl ? targetPage.updateUrl(url): url, snapshot);

       const {
            complete,
            interactive,
        } = hijackReadyState();

        

        
        animationNextPage(targetPage.skeletonElement(url) as HTMLElement);
        

        const animationPlayPromise = new Promise(r => {
            // play 300ms animation, body should be hide until this resolve
            setTimeout(r, 300);
        });

        const showBody = () => animationPlayPromise.then(() => {
            const hiddenStyle = document.body.querySelector('#lighthub-body-hidden');
            hiddenStyle && hiddenStyle.remove();
        });

        hijackPerformanceTiming();

        startTiming('load-html');
        // @ts-ignore
        hijackRequestStart();
        let _content = await runInQueue(() => entryPromise);
        endTiming('load-html');
        hijackResponseStart();


        

        const content = _content as string;
        startTiming('parse-html');
        const page = parsePage(content);
        endTiming('parse-html');

        

        if (asyncQueueId !== getAsyncQueueId()) {
            return;
        }

        

        
        startTiming('apply-page');

        await applySnapshot({
            headChildren: page.headChildren,
            bodyAttrs: page.bodyAttrs,
            bodyChildren: page.bodyChildren,
            window: getGlobalLightHub().initalWindow,
            windowListeners: [],
            documentListeners: [],
            timeoutTimers: [],
            intervalTimers: [],
            mutationObservers: [],
            htmlAttrs: [],
            keepBody: true,
            requestAnimationFrameListeners: [],
            requestIdleCallbackListeners: [],
            prototypes: lighthub.initalPrototypes,
        }, false, true, showBody);

        endTiming('apply-page');
        window.scroll(0, 0);

        

        nprogress.done();

        interactive();

        
        await runInQueue(() => applyDeferScriptInPage());
        

        complete();
        dispatchEvent('DOMContentLoaded');
        dispatchEvent('load');

        const skeleton = document.body.querySelector('#lighthub-skeleton-image');
        animationPlayPromise.then(() => {
            skeleton && skeleton.remove();
        });
        // if (content.length > 6000) {
        //     removeSkeletonHandler();
        // } else {
        // setTimeout(() => {
        //     removeSkeletonHandler();
        // }, 1000);
        // }

    } catch(e){

        if (isLightWran(e)) {
            return;
        }

        console.error('err when navigation', e, e.stack);

        if (process.env.NODE_ENV === 'production') {
            location.href = url;
        }
    }


}
